/* MyScent Adventskalender 2026: free gifts as 0 € cart lines, kept in sync with the number of calendars.
   1 calendar   -> Montblanc Duschgel + 1 Parfum-Gutschein
   2+ calendars -> Jimmy Choo (instead of Montblanc) + 1 Parfum-Gutschein per calendar
   Runs on every page (included from the header section). Gift products are tagged "geschenk-auto" and cost 0 €. */
(function () {
  'use strict';
  var CAL = 11194240467282;            // MyScent Adventskalender 2026 (product id)
  var MB = 55043479863634;             // Geschenk: Montblanc Explorer Duschgel (variant id)
  var JC = 55043480093010;             // Geschenk: Jimmy Choo I Want Choo With Love (variant id)
  var VC = 55043480322386;             // Geschenk: Parfum-Gutschein 80 € (variant id)
  var GIFTS = [MB, JC, VC];
  var nativeFetch = window.fetch.bind(window);
  var busy = false;

  function wanted(cart) {
    var n = 0;
    cart.items.forEach(function (i) { if (i.product_id === CAL) n += i.quantity; });
    var w = {};
    w[MB] = n === 1 ? 1 : 0;
    w[JC] = n >= 2 ? 1 : 0;
    w[VC] = n;
    return w;
  }

  function current(cart) {
    var h = {};
    GIFTS.forEach(function (g) { h[g] = 0; });
    cart.items.forEach(function (i) { if (GIFTS.indexOf(i.variant_id) > -1) h[i.variant_id] += i.quantity; });
    return h;
  }

  function refreshUi(cart) {
    var count = document.querySelector('[data-mh-count]');
    if (count && cart && typeof cart.item_count === 'number') { count.textContent = cart.item_count; count.hidden = !cart.item_count; }
    if (document.querySelector('[data-mct]')) { window.location.reload(); return; }
    if (typeof window.emit === 'function') window.emit('quick-cart:updated');
  }

  function sync(cart) {
    if (busy) return Promise.resolve(false);
    var w = wanted(cart), h = current(cart), updates = {}, diff = false;
    GIFTS.forEach(function (g) { if (w[g] !== h[g]) { updates[g] = w[g]; diff = true; } });
    if (!diff) return Promise.resolve(false);
    busy = true;
    return nativeFetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ updates: updates })
    })
      .then(function (r) { return r.json(); })
      .then(function (c) { busy = false; refreshUi(c); return true; })
      .catch(function () { busy = false; return false; });
  }

  function check() {
    return nativeFetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(sync)
      .catch(function () { return false; });
  }

  // Re-check after every cart change the theme makes (quick cart, cart page, product forms).
  window.fetch = function (input) {
    var p = nativeFetch.apply(window, arguments);
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    if (!busy && /\/cart\/(add|change|update|clear)(\.js)?/.test(url)) {
      p.then(function () { setTimeout(check, 60); }).catch(function () {});
    }
    return p;
  };

  // Upsell buttons: <button data-gift-upsell="VARIANT_ID">
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-gift-upsell]');
    if (!btn) return;
    e.preventDefault();
    btn.disabled = true;
    btn.classList.add('is-busy');
    nativeFetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(btn.dataset.giftUpsell, 10), quantity: 1 }] })
    })
      .then(function () { return check(); })
      .then(function (changed) {
        if (changed) return;
        return nativeFetch('/cart.js').then(function (r) { return r.json(); }).then(refreshUi);
      })
      .catch(function () { window.location.reload(); });
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', check); else check();
})();
